// History API mini router (no dependency). Adapted from web/src/core/router.ts.
export type RouteHandler = (params: Record<string, string>, root: HTMLElement) => void | Promise<void>;

interface Route {
  pattern: RegExp;
  keys: string[];
  handler: RouteHandler;
}

const routes: Route[] = [];
let notFound: RouteHandler = (_p, root) => {
  root.textContent = "404";
};
let afterResolve: ((path: string) => void) | null = null;

export function route(path: string, handler: RouteHandler): void {
  const keys: string[] = [];
  const pattern = new RegExp(
    "^" +
      path.replace(/:[^/]+/g, (m) => {
        keys.push(m.slice(1));
        return "([^/]+)";
      }) +
      "/?$",
  );
  routes.push({ pattern, keys, handler });
}

export function setNotFound(handler: RouteHandler): void {
  notFound = handler;
}

// Hook invoked after each successful resolve — used to sync sidebar active state.
export function onResolve(cb: (path: string) => void): void {
  afterResolve = cb;
}

export function navigate(to: string): void {
  history.pushState({}, "", to);
  resolve();
}

export function resolve(): void {
  const root = document.getElementById("app");
  if (!root) return;
  const path = location.pathname;
  for (const r of routes) {
    const m = r.pattern.exec(path);
    if (m) {
      const params: Record<string, string> = {};
      r.keys.forEach((k, i) => (params[k] = decodeURIComponent(m[i + 1] ?? "")));
      void r.handler(params, root);
      afterResolve?.(path);
      return;
    }
  }
  void notFound({}, root);
  afterResolve?.(path);
}

export function startRouter(): void {
  document.addEventListener("click", (e) => {
    const a = (e.target as HTMLElement).closest("a[data-link]");
    if (a instanceof HTMLAnchorElement && a.origin === location.origin) {
      e.preventDefault();
      navigate(a.pathname);
    }
  });
  window.addEventListener("popstate", resolve);
  resolve();
}
